/**
 * Created by Daniel on 05/14/2019.
 * Description:
 * dashboard wrapper
 * ------ maintenance history ------
*/

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { delay, filter, skip } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
    selector: 'dashboard-viewer-wrapper',
    templateUrl: './dashboard-viewer-wrapper.component.html',
    styleUrls: ['./dashboard-viewer-wrapper.component.scss']
})
export class DashboardViewerWrapperComponent implements OnInit {
    actionSubject$ = new Subject();
    isPageLoading = true;
    keyOfScreen = 'dashboardView';
    showDashboardPage = true;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._route.paramMap.pipe(
                skip(1)
            ).subscribe(() => this.initPage()),
            this.actionSubject$.pipe(
                filter(action => action['type'] === 'SET_PAGE_LOADING_STATUE'),
                delay(0), // use delay 0 for prepare render tile
            ).subscribe(() => {
                this.isPageLoading = false;
            })
        );
        this.initPage();
    }

    initPage() {
        this.isPageLoading = true;
        this.showDashboardPage = true;
        if (this._route.snapshot.paramMap.has('id')) {
            const id = this._route.snapshot.paramMap.get('id');
            this.keyOfScreen = id;
            // use delay to destory the dashboard-screen component, and re-init dashboard-screen component
            _.delay(() => {
                this.showDashboardPage = false;
            }, 250);
        }
    }
}
